import React, { useState } from "react";
import SharedHelmet from ".././Helmet";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة السرعة - كيفية حساب السرعة";
const DESCRIPTION = "حاسبة السرعة تقوم بحساب السرعة بناءً على المسافة والزمن.";
const KEYWORDS =
  "حساب السرعة, حاسبة السرعة, حساب السرعة بناءً على المسافة والزمن";
const OG_URL = "https://do-calculate.com/calculator/ar/velocity";
function VelocityCalculator() {
  const [distance, setDistance] = useState("");
  const [time, setTime] = useState("");
  const [velocity, setVelocity] = useState("");
  const [error, setError] = useState("");
  const handleCalculate = () => {
    if (!distance || !time) {
      setError("الرجاء إدخال المسافة والزمن بشكل صحيح");
      setVelocity("");
      return;
    }
    const distanceValue = parseFloat(distance);
    const timeValue = parseFloat(time);
    if (isNaN(distanceValue) || isNaN(timeValue) || timeValue <= 0) {
      setError("الرجاء إدخال قيم صحيحة وإيجابية للمسافة والزمن");
      setVelocity("");
      return;
    }
    const velocityValue = distanceValue / timeValue;
    setVelocity(velocityValue.toFixed(2));
    setError("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />         </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  هذه الحاسبة تساعدك على حساب السرعة بناءً على المسافة والزمن.
                  لاحتساب السرعة، قم بإدخال المسافة المقطوعة (بالكيلومترات)
                  والزمن (بالساعات).
                </p>
                <p>قانون حساب السرعة هو:</p>
                <p>
                  <b>
                    السرعة (كيلومتر/ساعة) = المسافة (كيلومتر) / الزمن (ساعة)
                  </b>
                </p>
                <p>
                  بعد إدخال القيم المناسبة، انقر على زر "احسب السرعة" للحصول على
                  النتيجة.
                </p>
              </div>
            </div>
               <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE} </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          المسافة (كيلومتر)
                        </label>
                      </b>
                      <input
                        type="number"
                        placeholder="80"
                        value={distance}
                        onChange={(e) => setDistance(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">الزمن (ساعة)</label>
                      </b>
                      <input
                        type="number"
                        placeholder="8"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب السرعة
                    </button>
                  </div>
                  <br />
                  <div>
                    {error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      <>
                        {velocity !== "" && (
                          <>
                            <p className="p-3 mb-2 bg-success text-white">
                              السرعة (كيلومتر/ساعة): {velocity}
                            </p>
                            <p className="p-3 mb-2 bg-info text-black">
                              خطوات الحل: <br />- قم بحساب السرعة بالاستناد إلى
                              القانون التالي: السرعة (كيلومتر/ساعة) = المسافة
                              (كيلومتر) / الزمن (ساعة)
                            </p>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <RelatedLinks />           </div>
        </div>
        <div className="col">
          <SecondAds />           <br />
          <MainCalculatorsList></MainCalculatorsList>
                     <br />
        </div>
      </div>
      {" "}
      <br />
    </div>
  );
}
export default VelocityCalculator;
